var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotography(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "https://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "photography") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons-304",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "photography",
    fillRule: "nonzero",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4382624,7.7506099 C15.8178068,7.27617944 16.3924326,7 17,7 L31,7 C31.6075674,7 32.1821932,7.27617944 32.5617376,7.7506099 L35.9612497,12 L40.9996703,12 C43.7558457,12 46,14.2344908 46,16.9910904 L46,36.0089096 C46,38.7642394 43.7615541,41 41.0035095,41 L6.99420208,41 C4.23707888,41 2,38.763897 2,36.0089096 L2,16.9910904 C2,14.2344908 4.24415431,12 7.00032973,12 L12.0387503,12 L15.4382624,7.7506099 Z M17.9612497,11 L14.5617376,15.2493901 C14.1821932,15.7238206 13.6075674,16 13,16 L7.00032973,16 C6.44943843,16 6,16.4475031 6,16.9910904 L6,36.0089096 C6,36.5543672 6.44582727,37 6.99420208,37 L41.0035095,37 C41.5534892,37 42,36.5540249 42,36.0089096 L42,16.9910904 C42,16.4475031 41.5505616,16 40.9996703,16 L35,16 C34.3924326,16 33.8178068,15.7238206 33.4382624,15.2493901 L30.0387503,11 L17.9612497,11 Z M24,34 C19.0294373,34 15,29.9705627 15,25 C15,20.0294373 19.0294373,16 24,16 C28.9705627,16 33,20.0294373 33,25 C33,29.9705627 28.9705627,34 24,34 Z M24,30 C26.7614237,30 29,27.7614237 29,25 C29,22.2385763 26.7614237,20 24,20 C21.2385763,20 19,22.2385763 19,25 C19,27.7614237 21.2385763,30 24,30 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotography);
export default __webpack_public_path__ + "static/media/photography.ceb6b9d69baf31cd94ff3bfffa778e8d.svg";
export { ForwardRef as ReactComponent };